module.exports = __webpack_public_path__ + "img/Wp_2075.ad2e569f.png";